import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import MainFrame from './components/index';
import React, { lazy } from 'react';


import Login from './pages/login';  // 登陆
import List from './pages/list';  // 列表
import ConferenceRoom from './pages/conferenceRoom';  // 列表


// const withLoadingComponent: any = (comp: JSX.Element) => (
//   <React.Suspense fallback={<div>Loading...</div>}>
//     {comp}
//   </React.Suspense>
// )
// const Yqgh = lazy(() => import("./pages/mathematicalIntelligencePort/yqgh"))

const App = () => {
  return (
    <HashRouter>
      <MainFrame>
        {/* 重定向 */}
        <Redirect from="/" to="/login" />
        <Switch>
          {/* <Route exact path="/hubCenter/zhengzhouPlanning" children={<ZhengzhouPlanning />} /> */}
          <Route exact path="/login" component={Login} />
          <Route exact path="/list" component={List} />
          <Route exact path="/conferenceRoom" component={ConferenceRoom} />
        </Switch>
      </MainFrame>
    </HashRouter>
  );
}

export default App;